import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AvatarService } from '../services/avatar.service';
import { IonicModule, ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-scheduled-rides-list',
    templateUrl: './scheduled-rides-list.component.html',
    styleUrls: ['./scheduled-rides-list.component.scss'],
    standalone: true,
    imports: [IonicModule, CommonModule, TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ScheduledRidesListComponent implements OnInit {
    scheduledRides$: Observable<any[]>;

    constructor(
        private avatar: AvatarService,
        private modalCtrl: ModalController
    ) { }

    ngOnInit() {
        this.scheduledRides$ = this.avatar.getScheduledRides();
    }

    async cancelRide(rideId: string) {
        if (confirm('Are you sure you want to cancel this scheduled ride?')) {
            await this.avatar.cancelScheduledRide(rideId);
        }
    }

    close() {
        this.modalCtrl.dismiss();
    }

    formatDate(dateStr: string) {
        return new Date(dateStr).toLocaleString([], {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
}
